import './mainSkeleton.scss';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export default function MainSkeleton() {
  return (
    <div className='main-skeleton-container'>
      <Skeleton duration={0.5} className='main-skeleton-nav'/> {/* Navbar */}
        <div className='main-skeleton'>
            <Skeleton duration={0.5} className='main-skeleton-left' width={100}/>{/* Submenú */}

            <div className='main-skeleton-wrapper'>
                <div className='main-skeleton-body'>
                    <div className='panel-recurso-main'>
                        <Skeleton  duration={0.5} className='main-skeleton-item'/>
                        <Skeleton  duration={0.5} className='main-skeleton-item'/>
                    </div>

                    <div className='panel-recurso-img'>
                        <Skeleton duration={0.5} className='main-skeleton-item'/>
                    </div>
                </div>
                <div className='main-gallery-skeleton-list'>
                    {new Array(3).fill(null).map((_, index) => (
                        <Skeleton key={'gallery-item-list'+index} duration={0.5} />
                    ))}
                </div>
            </div>
      </div>
    </div>
  );
}
